import { Component, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SeguroI } from '@app/interfaces/gestion-vehicular/seguro.interface';
import { TranslationService } from '../../../translation/translation.service';

@Component({
  selector: 'app-agregar-nuevo',
  standalone: false,
  templateUrl: './agregar-nuevo.component.html',
  styleUrl: './agregar-nuevo.scss'
})
export class AgregarNuevoComponent {
  @Input() header!: string;
  @Input() campos: any[] = [];
  @Input() opcionesSelect: Record<string, any[]> = {};
  @Output() guardar = new EventEmitter<SeguroI>();
  showDialog = false;

  private fb = inject(FormBuilder);
  private readonly translationService = inject(TranslationService);

  formulario: FormGroup = this.fb.group({});

  //! Para componente flota, el campo 'cliente' depende de 'titularidad'
  opcionesTitularidad: { [key: string]: { label: string; value: string }[] } = {
    'Alquilado': [
      { label: 'Surcante', value: 'Surcante' },
      { label: 'Transporte El Gato', value: 'Transporte El Gato' },
      { label: 'Turismo Patagonia', value: 'Turismo Patagonia' },
    ],
    'Propio': [
      { label: 'CN Sapag', value: 'CN Sapag' }
    ]
  };

  ngOnChanges(changes: SimpleChanges) {
    if (changes['campos'] && this.campos?.length) {
      this.inicializarFormulario();
    }
  }

  inicializarFormulario() {
    const group: Record<string, any> = {};
    this.campos.forEach(campo => {
      const validators = campo.requerido ? [Validators.required] : [];
      group[campo.formControlName] = [
        campo.tipo === 'listbox' || campo.tipo === 'multiselect' ? [] : '',
        validators
      ];
    });
    this.formulario = this.fb.group(group);
  }

  abrirDialogo() {
    this.showDialog = true;
  }

  cerrarDialogo() {
    this.showDialog = false;
    this.formulario.reset();
  }

  agregarNuevo() {
    if (this.formulario.valid) {
      this.guardar.emit(this.formulario.value as SeguroI);
      this.cerrarDialogo();
    } else {
      this.formulario.markAllAsTouched();
    }
  }

  obtenerOpciones(campo: string): any[] {
    return [...(this.opcionesSelect[campo] || [])];
  }

  onFileChange(event: any, controlName: string) {
    const file = event.target.files[0];
    if (file) {
      this.formulario.get(controlName)?.setValue(file);
    }
  }

  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }
}